import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faClose,
  faPhone,
  faShareNodes,
} from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next'
import InstagramIcon from '../../assets/icons/instagram.svg?react'
import Logo from '../../assets/images/logo_bg.png'

import { useAppNavigate, useAppType } from '../../context/AppContext'
import { useNavigate } from 'react-router-dom'
import { useGetAppStatusQuery } from '../../store/api/appStatusApi'
import { INSTAGRAM_LINK } from '../../utils/constants'
import './Sidebar.scss'

type Props = {
  setIsOpen?: (isOpen: boolean) => void
  isOpen?: boolean
}
const c = 'sidebar-menu'

const Sidebar = (props: Props) => {
  const { t } = useTranslation()
  const navigate = useAppNavigate()
  const navigateRaw = useNavigate()
  const appType = useAppType()
  const { data: appStatus } = useGetAppStatusQuery()

  const otherApp = appType === 'sushi' ? 'catering' : 'sushi'
  const otherAppLabel = appType === 'sushi' ? 'PandaCatering' : 'PandaSushi'
  const otherAppDisabled =
    appType === 'sushi'
      ? (appStatus?.isCateringDisabled ?? false)
      : (appStatus?.isSushiDisabled ?? false)

  return (
    <div className={`${c} ${props.isOpen ? 'open' : ''}`}>
      <div className={`${c}__close`}>
        <FontAwesomeIcon
          icon={faClose}
          onClick={() => props.setIsOpen?.(false)}
        />
      </div>
      <div className={`${c}__content`}>
        <div className={`${c}__content-logo`}>
          <img src={Logo} alt='logo'></img>
        </div>
        <div className={`${c}__content-links`}>
          <div
            className={`${c}__content-links-link`}
            onClick={() => {
              navigate('/')
              props.setIsOpen?.(false)
            }}
          >
            {t('MENU')}
          </div>
          <div
            className={`${c}__content-links-link`}
            onClick={() => {
              props.setIsOpen?.(false)
              navigate('/delivery-conditions')
            }}
          >
            {t('DELIVERY_CONDITIONS')}
          </div>
          {!otherAppDisabled && (
            <div
              className={`${c}__content-links-link ${c}__content-links-link--switch`}
              onClick={() => {
                navigateRaw(`/${otherApp}`)
                props.setIsOpen?.(false)
              }}
            >
              <span className={`${c}__content-links-link-switch-text`}>
                {otherAppLabel}
              </span>
            </div>
          )}
        </div>
        <div className={`${c}__content-info`}>
          <div className={`${c}__content-info-contact`}>
            <div className={`${c}__content-info-contact-icon`}>
              <FontAwesomeIcon icon={faPhone} />
            </div>
            <div className={`${c}__content-info-contact-item`}>
              <div className={`${c}__content-info-contact-item-label`}>
                {t('CONTACT_US')}
              </div>
              <div className={`${c}__content-info-contact-item-value`}>
                069 388 892 | 068 247 847
              </div>
            </div>
          </div>
          <div className={`${c}__content-info-socials`}>
            <div className={`${c}__content-info-socials-icon`}>
              <FontAwesomeIcon icon={faShareNodes} />
            </div>
            <div className={`${c}__content-info-socials-item`}>
              <div className={`${c}__content-info-socials-item-label`}>
                {t('SOCIALS')}
              </div>
              <div className={`${c}__content-info-socials-item-value`}>
                <a href={INSTAGRAM_LINK} target='_blank' rel='noreferrer'>
                  <InstagramIcon />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Sidebar
